import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { Store, select } from '@ngrx/store';
import { IAppState } from '../../store/state/app.state';
import { selectIdentify } from '../../store/selectors/identify.selectors';
import { first, flatMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {selectCID} from '../../store/selectors/page.selectors';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  // identifyObs$ = this._store.pipe(select(selectIdentify));
  pageCID$ = this._store.pipe(select(selectCID));

  constructor(private _store: Store<IAppState>) {}
  //TODO DA SPIEGARE CL
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    if (req.url.includes('slack')) {
      return next.handle(req);
    }
    if (req.url.includes('jsonip')) {
      return next.handle(req);
    }
    if (req.url.includes('seeip')) {
      return next.handle(req);
    }
    if (req.url.includes('s87533')) {
      return next.handle(req);
    }
    if (req.url.includes('restippica-staging-az')) {
      return next.handle(req);
    }

    if (req.url.includes('rest-staging.mediasystemtechnologies.it/')) {
      const authReq = req.clone({
        headers: req.headers.set('device', environment.uniqueCID),
        url: req.url + '?ngsw-bypass'
      });
      return next.handle(authReq);
    }

    if (req.url.includes('fe-proxyhts-tot-mst.mstchannel.com/')) {
      const authReq = req.clone({
        headers: req.headers.set('device', environment.uniqueCID),
        url: req.url + '?ngsw-bypass'
      });
      return next.handle(authReq);
    }
    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.

    return this.pageCID$.pipe(
      first(),
      flatMap((data) => {
        let authReq = !!data
          ? req.clone({
              headers: req.headers.set('device', data),
            })
          : req;
        if (req.url.includes('rest')) {
          authReq = authReq.clone({
            url: req.url + '?ngsw-bypass'
          });
        }
        return next.handle(authReq);
      })
    );
  }
}
